module.exports = __webpack_public_path__ + "static/media/foodprint_app6_preview.da9c3871.jpg";